import { getToken } from "./auth.service";

const API_URL = process.env.REACT_APP_API_URL;

export const getWelcomeContent = async (section?: string) => {
  const url = section
    ? `${API_URL}/welcome?section=${section}`
    : `${API_URL}/welcome`;
  return await (await fetch(url)).json();
};

export const createWelcomeContent = async (data: any) => {
  return await (
    await fetch(`${API_URL}/welcome`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    })
  ).json();
};

export const updateWelcomeContent = async (id: number, data: any) => {
  return await (
    await fetch(`${API_URL}/welcome/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(data),
    })
  ).json();
};

export const deleteWelcomeContent = async (id: number) => {
  return await (
    await fetch(`${API_URL}/welcome/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
  ).json();
};

export const uploadWelcomeImage = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_URL}/welcome/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  });
  return await response.json();
};
